module.exports = __webpack_public_path__ + "img/02b03e2080a1b739324652b81ca5ee7.716d418d.png";